import { combineReducers } from 'redux-loop';

import authReducer, { base as authBase } from './auth';
import extraServicesReducer, {
  base as extraServicesBase,
} from './extraServices';
import historyReducer, { base as historyBase } from './history';
import wishListReducer, { base as wishListBase } from './wishList';
import {
  reducer_isOpenModalLikeListing,
  base as baseIsOpenModalLikeListing,
} from '../component/data/isOpenModalLikeListing';

export default combineReducers({
  [authBase]: authReducer(),
  [extraServicesBase]: extraServicesReducer,
  [historyBase]: historyReducer(),
  [wishListBase]: wishListReducer(),
  [baseIsOpenModalLikeListing]: reducer_isOpenModalLikeListing,
});
